<template>
  <div>
    <div class="link" @click="openModal">
      <img src="@/assets/ArrowHLink14.svg" />
      <span>{{ $t('community.communityInfo.leaveCommunity') }}</span>
    </div>
    <modal-confirm @confirm="leaveCommunity()"
                   @close="closeModal()"
                   :title="$t('community.communityInfo.leaveCommunity')"
                   :message="$t('community.communityInfo.leaveCommunityConfirmation')"
                   :show-modal="showModal"
    />
  </div>
</template>
<script>
import ModalConfirm from '@/components/shared/ModalConfirm'

export default {
  name: 'LeaveCommunityModal',
  components: { ModalConfirm },
  data() {
    return {
      showModal: false
    }
  },
  props: {
    communityId: {
      type: String,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    openModal() {
      this.showModal = true
    },
    async leaveCommunity() {
      await this.$store.dispatch('leaveCommunity', this.communityId)
      this.showModal = false
      this.$router.push({ name: 'homePage' })
    }
  }
}
</script>

<style scoped lang="scss">

.link {
  color: $primary-color;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 1.2rem;

  &:hover {
    text-decoration: underline;
  }
}

</style>
